const languageSwitch = document.querySelector('.language-switch');

if (languageSwitch) {
  const toggleLanguageModal = (toggle) => {
    document.body.classList.toggle('is-open-language', toggle);
    toggleBodyScrollLock(toggle);
  };

  // Close modal
  attachEvent('[data-close-language-modal]', 'click', () => {
    toggleLanguageModal(false);
  });

  // Open modal
  attachEvent('.site-header__language-btn', 'click', () => {
    toggleLanguageModal(true);
  });

  // Close modal on Escape key
  onKeydown('escape', () => {
    toggleLanguageModal(false);
  });
}
